import React from 'react';
import imgUrl from './img/qr.png';
import './index.less';

class Index extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            QR: ''
        };
        
    }

    componentDidMount() {
    }
    
    
    render() {
        let { type } = this.state;
        return (
            <div className="IndexBox">
                <div className="IndexBG">
                    <h1>慧联供应商系统已升级为小程序</h1>
                    <img src={imgUrl}/>
                    <p>请长按二维码前往小程序继续使用</p>
                </div>
            </div>
        );
    }
}

export default Index;


// WEBPACK FOOTER //
// ./src/pages/index/index.js